<template>
  <div>
    <div class="row">
      <div class="col-md-4 mb-2">
        <label>Серия</label>
        <IMaskComponent
          v-model="data.series"
          type="text"
          class="form-control"
          required
        />
      </div>
      <div class="col-md-4 mb-2">
        <label>Номер</label>
        <IMaskComponent
          v-model="data.number"
          type="text"
          class="form-control"
          required
        />
      </div>
    </div>
    <hr class="mb-4">
  </div>
</template>

<script>
export default {
  name: 'DocumentPassCarriageLicenceEdit',
  props: {
    documentData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      data: {
        number: '',
        series: ''
      }
    }
  },
  watch: {
    data: {
      immediate: true,
      handler () {
        this.$emit('update', {
          type: 'pass_carriage_licence',
          data: this.data
        })
      },
      deep: true
    }
  },
  mounted () {
    if (this.documentData) {
      this.data = this.documentData
    }
  }
}
</script>
